import { styled } from "goober";

const Outer = styled("div")`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  height: 100%;

  path {
    stroke: var(--text-primary);
    opacity: 0.2;
  }
`;

const Item = styled("div")`
  border-color: var(--text-primary);
  border-style: solid;
  border-width: 0;
  opacity: 0.2;
`;

const Inner = styled("div")`
  display: flex;
  flex-direction: row;
`;

const getTopRightArc = (size: number) =>
  `M${size} ${size} A${size} ${size} 0 0 1 0 0`;

const Bend = ({ radius }: { radius: number }) => {
  const arc = getTopRightArc(radius);
  return (
    <svg
      style={{ marginLeft: 0.5 }}
      width={radius}
      height={radius}
      overflow="visible"
      viewBox={`0 0 ${radius} ${radius}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={arc} />
    </svg>
  );
};

type Props = {
  variant: "branch" | "terminate" | "through";
  gridSize: number;
};

export function Noodle({ variant, gridSize }: Props) {
  return (
    <Outer>
      {variant === "branch" ? (
        <>
          <Item style={{ height: gridSize, borderLeftWidth: 1 }} />
          <Inner style={{ height: gridSize }}>
            <Item
              style={{
                flex: 1,
                borderLeftWidth: 1,
                borderBottomWidth: 1,
              }}
            />
          </Inner>
          <Item style={{ flex: 1, borderLeftWidth: 1 }} />
          <Item style={{ flex: 1, borderLeftWidth: 1 }} />
        </>
      ) : variant === "terminate" ? (
        <>
          <Item style={{ height: gridSize, borderLeftWidth: 1 }} />
          <Inner style={{ height: gridSize }}>
            <Bend radius={gridSize} />
            <Item
              style={{ flex: 1, marginBottom: -0.5, borderBottomWidth: 1 }}
            />
          </Inner>
          <Item style={{ flex: 1 }} />
          <Item style={{ flex: 1 }} />
        </>
      ) : (
        <Item style={{ flex: 1, borderLeftWidth: 1 }} />
      )}
    </Outer>
  );
}
